const developmentOrigin = 'https://development.api.maxpreps.com';

const apiEnvironments = {
  dev: developmentOrigin,
  development: developmentOrigin,
  staging: 'https://stag.api.maxpreps.com',
  production: 'https://production.api.maxpreps.com'
};

export default apiEnvironments;
